import { FhsAxios } from "../../services/axios";

export default {
  state: {
    documents: []
  },
  actions: {
    fetchDocuments({ getters, commit }) {
      let url = "user/get-user-documents-list";
      FhsAxios.get(url, {
        data: {}
      }).then(response => {
        let documents = response.data.result;
        commit("setDocuments", documents);
      });
    }
  },
  mutations: {
    setDocuments(state, documents) {
      state.documents = documents;
    }
  },
  getters: {
    documents(state) {
      return state.documents;
    }
  }
};
